import { useRouter } from 'next/router'
import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { Locations, NavigationEvents } from '@mc/track-event'
import Nav from '@mc/navigation'
import { paths } from '@mc/paths'

import { GuestPass } from 'types/data/GuestPass'
import {
  getPageSourceFromPath,
  shouldHideEnterpriseCTAInNav,
  shouldScrollToForm,
  trackBrowseSkillsCatalogCTAClick,
} from 'components/Navigation/enterprise/utils'
import { trackNavClick } from 'components/Navigation/events'

import { Callout } from './EnterpriseVariant1Callout'

export const EnterpriseMobileMenuVariant1 = ({
  newForBusinessPageEnabled = false,
}: {
  newForBusinessPageEnabled?: boolean
}) => {
  const { t } = useTranslation('@mc/next')
  const { guestPass } = useStaticData<{
    guestPass: GuestPass
  }>()
  const { pathname, query } = useRouter()

  return (
    <>
      {newForBusinessPageEnabled && (
        <div className='mc-ml-4 mc-mt-5'>
          <h2 className='mc-text-small mc-text-color--tint mc-mb-3'>
            {t('nav.cta.solutions')}
          </h2>
          <Nav.MenuLink
            onClick={trackNavClick(
              'Collective',
              NavigationEvents.LEVELS.SECONDARY,
            )}
            href={paths.enterpriseCollective}
          >
            {t('nav.cta.collective')}
          </Nav.MenuLink>
          <Nav.MenuLink
            onClick={trackNavClick(
              'Accelerator',
              NavigationEvents.LEVELS.SECONDARY,
            )}
            href={paths.enterpriseAccelerator}
          >
            {t('nav.cta.accelerator')}
          </Nav.MenuLink>
        </div>
      )}

      {guestPass?.eligible && (
        <Nav.MenuLink
          onClick={trackNavClick('Gift', NavigationEvents.LEVELS.SECONDARY)}
          href={paths.checkoutGift()}
        >
          {t('nav.cta.gift')}
        </Nav.MenuLink>
      )}

      <Nav.MenuLink
        href={paths.enterpriseSkillsLibrary}
        onClick={trackBrowseSkillsCatalogCTAClick({
          action: t('nav.cta.browseSkillsLibrary'),
          level: NavigationEvents.LEVELS.SECONDARY,
          pathname,
          query,
        })}
      >
        {t('nav.cta.browseSkillsLibrary')}
      </Nav.MenuLink>

      <Nav.MenuLink
        onClick={trackNavClick('Support', NavigationEvents.LEVELS.SECONDARY)}
        href={paths.helpCenter}
      >
        {t('nav.cta.support')}
      </Nav.MenuLink>

      <Nav.MenuLink
        onClick={trackNavClick('Log In', NavigationEvents.LEVELS.SECONDARY)}
        href={paths.logIn()}
      >
        {t('nav.cta.login')}
      </Nav.MenuLink>

      {!shouldHideEnterpriseCTAInNav(pathname) && (
        <Callout
          pageSource={getPageSourceFromPath({ pathname, query })}
          location={Locations.NAVIGATION}
          scrollToForm={shouldScrollToForm(pathname)}
          href={
            shouldScrollToForm(pathname)
              ? '#contact-form'
              : paths.enterprisePurchase
          }
        />
      )}
    </>
  )
}
